import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const COLS = [
    {
        title: 'Interim.',
        links: [
            { label: 'Get a job',    to: '/get-job' },
            { label: 'Create a job', to: '/create-job' },
            { label: 'My listings',  to: '/my-listings' },
        ],
    },
    {
        title: 'Explore',
        links: [
            { label: 'About us',   to: '/about' },
            { label: 'People',     to: '/people' },
            { label: 'Contact us', to: '/contact' },
        ],
    },
    {
        title: 'Follow us',
        links: [
            { label: 'Instagram', href: 'https://www.instagram.com/interim_day_jobs/', external: true },
            { label: 'TikTok',    href: 'https://tiktok.com',                          external: true },
            { label: 'LinkedIn',  href: 'https://www.linkedin.com/company/interimjobs', external: true },
        ],
    },
    {
        title: 'Privacy',
        links: [
            { label: 'Terms & Conditions', to: '/terms' },
        ],
    },
];

const Footer = () => {
    const [jobCount, setJobCount] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/jobs/count`)
            .then(r => setJobCount(r.data))
            .catch(() => {});
    }, []);

    return (
        <footer className="ix-footer">
            <div className="ix-container">

                {/* Top grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1.1fr 2.4fr',
                    gap: '64px',
                    paddingBottom: '56px',
                    borderBottom: '1px solid color-mix(in srgb, var(--teal-100) 18%, transparent)',
                }}
                    className="ix-footer-top"
                >
                    {/* Brand column */}
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                            <span className="ix-footer-mark">
                                <img src="/brand/interim-mark-white.svg" alt="Interim" />
                            </span>
                            <h2 style={{
                                fontSize: '36px', fontWeight: 600, letterSpacing: '-0.03em',
                                margin: 0, color: '#fff',
                                fontFamily: 'var(--font-sans)',
                            }}>
                                Interim<span style={{ color: 'var(--teal-300)' }}>.</span>
                            </h2>
                        </div>
                        <p style={{
                            fontSize: '15px', lineHeight: 1.55, margin: '0 0 20px',
                            color: 'color-mix(in srgb, var(--teal-100) 88%, white)',
                            maxWidth: '26ch',
                        }}>
                            Short jobs. Real people.{' '}
                            <span style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic' }}>Same day.</span>
                        </p>
                        <div style={{
                            display: 'inline-flex', alignItems: 'center', gap: '10px',
                            padding: '8px 14px',
                            borderRadius: 'var(--r-pill)',
                            background: 'color-mix(in srgb, var(--teal-100) 8%, transparent)',
                            border: '1px solid color-mix(in srgb, var(--teal-100) 18%, transparent)',
                            fontSize: '12px',
                        }}>
                            <span className="ix-footer-pulse" />
                            <span className="mono">
                                {jobCount !== null ? `${jobCount.toLocaleString()} job${jobCount !== 1 ? 's' : ''} open right now` : 'Jobs open right now'}
                            </span>
                        </div>
                    </div>

                    {/* Link columns */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }} className="ix-footer-cols">
                        {COLS.map((col) => (
                            <div key={col.title}>
                                <h4 style={{
                                    fontSize: '13px', fontWeight: 600, color: '#fff',
                                    margin: '0 0 16px', letterSpacing: '-0.01em',
                                    fontFamily: 'var(--font-sans)',
                                }}>
                                    {col.title}
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {col.links.map((link) => (
                                        <li key={link.label}>
                                            {link.external ? (
                                                <a
                                                    href={link.href}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="ix-footer-link"
                                                >
                                                    {link.label}
                                                </a>
                                            ) : (
                                                <Link to={link.to} className="ix-footer-link">
                                                    {link.label}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bottom bar */}
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    paddingTop: '28px',
                    fontSize: '12px',
                    color: 'color-mix(in srgb, var(--teal-100) 70%, white)',
                }}>
                    <span className="mono">© Interim 2025</span>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {['English', '€ EUR'].map((pill) => (
                            <span key={pill} style={{
                                padding: '5px 12px',
                                borderRadius: 'var(--r-pill)',
                                background: 'color-mix(in srgb, var(--teal-100) 8%, transparent)',
                                border: '1px solid color-mix(in srgb, var(--teal-100) 18%, transparent)',
                                fontSize: '11px',
                            }}>
                                {pill}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            {/* Responsive footer styles */}
            <style>{`
                @media (max-width: 880px) {
                    .ix-footer-top { grid-template-columns: 1fr !important; gap: 40px !important; }
                    .ix-footer-cols { grid-template-columns: repeat(2, 1fr) !important; }
                }
                @media (max-width: 480px) {
                    .ix-footer-cols { grid-template-columns: 1fr !important; }
                }
            `}</style>
        </footer>
    );
};

export default Footer;
